<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M28.7 24l-11-19a2 2 0 00-3.46 0L3.3 24A2 2 0 005 27h22a2 2 0 001.73-3zM5 25L16 6l11 19z"/><path d="M15 12v6.5a1 1 0 002 0V12a1 1 0 00-2 0zM16.57 20.61l-.28-.08a1.42 1.42 0 00-.58 0l-.28.08-.26.14a2.11 2.11 0 00-.23.19 1.51 1.51 0 00.49 2.45 1.56 1.56 0 00.57.11 1.5 1.5 0 001.5-1.5 1.36 1.36 0 000-.29 1.31 1.31 0 00-.09-.28 1.26 1.26 0 00-.13-.26 2.11 2.11 0 00-.19-.23 1.45 1.45 0 00-.23-.19 1.59 1.59 0 00-.29-.14z"/></svg>